import { Link, useParams } from "react-router-dom";
import { useSite } from "@/lib/site";
import { useSeo } from "@/hooks/useSeo";
import Stock from "./Stock";
import { SEO_LANDINGS } from "@/lib/content";

const TITLES = {
  privacy: "Privacy Policy", cookies: "Cookie Policy", terms: "Website Terms", "vehicle-sales": "Vehicle Sales Terms",
  reservations: "Reservation Terms", complaints: "Complaints Procedure", finance: "Finance Disclosure",
};

function LegalBody({ text }) {
  const blocks = [];
  text.split("\n").filter((l) => l.trim()).forEach((l) => {
    const last = blocks[blocks.length - 1];
    if (l.startsWith("- ")) { if (last?.type === "ul") last.items.push(l.slice(2)); else blocks.push({ type: "ul", items: [l.slice(2)] }); }
    else blocks.push(l.startsWith("## ") ? { type: "h2", text: l.slice(3) } : { type: "p", text: l });
  });
  return blocks.map((b, i) => b.type === "h2" ? <h2 key={i} className="!mt-10 font-serif text-3xl text-charcoal">{b.text}</h2>
    : b.type === "ul" ? <ul key={i} className="list-disc space-y-2 pl-5">{b.items.map((t) => <li key={t}>{t}</li>)}</ul>
    : <p key={i}>{b.text}</p>);
}

export function Legal() {
  const { page } = useParams();
  const site = useSite();
  const title = TITLES[page] || "Legal";
  useSeo({ title: `${title} | Cirencester 4x4`, path: `/legal/${page}` });
  return (
    <main className="mx-auto max-w-3xl px-5 pb-28 pt-36 sm:px-8 lg:pt-44" data-testid="legal-page">
      <p className="eyebrow text-forest">Legal</p>
      <h1 className="mt-4 font-serif text-5xl text-charcoal">{title}</h1>
      <div className="prose-c4 mt-10 space-y-4 text-base text-charcoal/85" data-testid="legal-content"><LegalBody text={site.legal?.[page] || "[Placeholder content — to be supplied.]"} /></div>
    </main>
  );
}

export function NotFound() {
  useSeo({ title: "Page not found | Cirencester 4x4" });
  return (
    <main className="mx-auto max-w-3xl px-5 pb-28 pt-44 text-center" data-testid="not-found">
      <p className="font-serif text-8xl italic text-stone-dark">404</p>
      <h1 className="mt-4 font-serif text-4xl">This lane doesn’t go anywhere.</h1>
      <Link to="/" className="btn btn-primary mt-8">Return home</Link>
    </main>
  );
}

export function SeoLanding() {
  const { slug } = useParams();
  const cfg = SEO_LANDINGS[slug];
  if (!cfg) return <NotFound />;
  return <Stock key={slug} preset={cfg.filter} heading={cfg.h1} intro={cfg.intro} seoPath={`/used/${slug}`} />;
}
